import {ListItem} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';

const ResultListItem = withStyles(theme => ({
    root: {
        '&$selected, &$selected:hover, &:hover': {
            backgroundColor: 'transparent',
        },
        margin: 0,
    },
    selected: {
        backgroundColor: 'transparent',
    },
}))(ListItem);

export default ResultListItem;
